import { ChangeDetectionStrategy, Component, Injector, OnDestroy, OnInit } from '@angular/core';

import { StoreService } from "../store/store.service";
import { StepManagerService } from "@core/services/online-credit/step-manager.service";
import { LifecycleHookLogs } from '@shared/decorators/lifecycle-hook-logs/lifecycle-hook-logs.decorator';
import { UntilDestroy } from '@ngneat/until-destroy';

@LifecycleHookLogs()
@UntilDestroy()
@Component({
    selector: 'app-application-sending-step',
    templateUrl: './application-sending-step.page.html',
    styleUrls: ['./application-sending-step.page.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})

export class ApplicationSendingStepPage implements OnInit, OnDestroy {
  public id;

  private stepManager: StepManagerService;

  constructor(
    private injector: Injector
  ) {
    this.id = this.injector.get(StoreService).value.application.id;
    this.stepManager = this.injector.get(StepManagerService);
  }

  ngOnInit() {
    setTimeout(() => {
      this.stepManager.setStepLoaded(true);
    })
  }

  ionViewWillEnter() {
  }

  ngOnDestroy() {
  }

  ionViewWillLeave() {
  }

  cancel() {
    this.stepManager.goToRoot();
  }
}
